import React, { useEffect, useState } from "react";

import { Box, Grid, Typography } from "@mui/material";
import { serviceProvider } from "../../provider/serviceProvider";
import { toast } from "react-toastify";
import SelectFieldComponent from "../common/SelectFieldComponent";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "../common/ButtonComponent";
import InputFieldComponent from "../common/InputFieldComponent";
import { sessionUtility } from "../../utility/sessionUtility";
const initialUserInput = {
  email: "",
  fullName: "",
  mobileNumber: "",
  uid: "",
  roleId: "",
};
const EditUserModalBody = ({
  handleCloseEditUserModal,
  userId,
  roleId,
  pageState,
  getUsersList,
  isActive,
  userDetail,
}: any) => {
  const [userInput, setUserInput] = useState(initialUserInput);
  const [loader, setLoader] = useState<boolean>(false);
  const [allRoles, setAllRoles] = useState([]);
  const navigate = useNavigate();
  const uId = sessionUtility.getAuthentication().session?.uId as string;

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setUserInput({ ...userInput, [name]: value });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const logout = () => {
    window.localStorage.clear();
    navigate("/login");
  };

  const [errors, setErrors] = useState<any>({});

  const validate = () => {
    const newErrors: any = {};
    if (!userInput.fullName.trim()) {
      newErrors.fullName = "Full Name is required";
    }
    if (!userInput.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(userInput.email)) {
      newErrors.email = "Enter a valid email address";
    }
    if (!userInput.mobileNumber.trim()) {
      newErrors.mobileNumber = "Mobile Number is required";
    } else if (!/^\d{10}$/.test(userInput.mobileNumber)) {
      newErrors.mobileNumber = "Enter a valid 10-digit number";
    }
    if (!userInput.roleId) {
      newErrors.roleId = "Role is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEditUser = async (userId: string) => {
    if (!validate()) return;

    const changesInUser =
      userInput.fullName !== userDetail.fullName ||
      userInput.email !== userDetail.email ||
      userInput.mobileNumber !== userDetail.mobileNumber;

    const changesInRole = userInput.roleId !== roleId;

    try {
      setLoader(true);

      // 1️⃣ Update user details if changed
      if (changesInUser) {
        const userPayload = {
          email: userInput.email,
          fullName: userInput.fullName,
          mobileNumber: userInput.mobileNumber,
          uid: userInput.uid,
        };

        const res = await serviceProvider.userService.put(
          `${uId}/admin`,
          userPayload
        );

        if (res.responseCode !== 200) {
          toast.error(res?.message || "User update failed!");
          setLoader(false);
          return;
        }
        toast.success("User details updated");
      }

      // 2️⃣ Update role if changed
      if (changesInRole) {
        const resRole = await serviceProvider.userService.put(
          `${userId}/roles/${userInput.roleId}`,
          {}
        );
        if (resRole.responseCode !== 200) {
          toast.error(resRole?.message || "Role update failed!");
          setLoader(false);
          return;
        }
        toast.success("Role updated");
      }

      // Refresh list
      const query = `search?uId=NA&email=all&fullName=all&isActive=${isActive}&offset=${pageState.page}&limit=${pageState.pageSize}&order=recordUpdatedts.desc&profile=BASIC`;
      getUsersList(query);

      handleCloseEditUserModal();
    } catch (err: any) {
      toast.error(err?.data?.message || "Something went wrong");
      handleCloseEditUserModal();
    } finally {
      setLoader(false);
    }
  };

  const getAllRoles = () => {
    serviceProvider.roleService
      .getAllRoles()
      .then((res) => {
        if (res.responseCode === 200) {
          setAllRoles(res.data);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getAllRoles();
  }, []);

  useEffect(() => {
    if (userDetail) {
      setUserInput({
        email: userDetail.email || "",
        fullName: userDetail.fullName || "",
        mobileNumber: userDetail.mobileNumber || "",
        uid: userDetail.uid || "",
        roleId: roleId || "",
      });
    } else {
      setUserInput(initialUserInput);
    }
  }, [roleId, userDetail]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} className="modal-table-container">
        <Grid container className="heading">
          <Grid item xs={12}>
            <Typography variant="h6" component="h6">
              Edit User
            </Typography>
          </Grid>
        </Grid>

        <Grid container rowSpacing={2}>
          <Grid item xs={12}>
            <Box
              pl="10px"
              pr="10px"
              border="1px solid gray"
              borderRadius="20px"
            >
              <InputFieldComponent
                id="user-fullname"
                type="text"
                name="fullName"
                placeholder="Enter Fullname"
                value={userInput.fullName}
                onChange={handleInputChange}
              />
            </Box>
            <span className="modalError">{errors.fullName}</span>
          </Grid>
          <Grid item xs={12}>
            <Box
              pl="10px"
              pr="10px"
              border="1px solid gray"
              borderRadius="20px"
            >
              <InputFieldComponent
                id="user-email"
                type="text"
                name="email"
                placeholder="Enter email"
                value={userInput.email}
                onChange={handleInputChange}
              />
            </Box>
            <span className="modalError">{errors.email}</span>
          </Grid>
          <Grid item xs={12}>
            <Box
              pl="10px"
              pr="10px"
              border="1px solid gray"
              borderRadius="20px"
            >
              <InputFieldComponent
                id="user-fullname"
                type="number"
                name="mobileNumber"
                placeholder="Enter mobileNumber"
                value={userInput.mobileNumber}
                onChange={handleInputChange}
              />
            </Box>
            <span className="modalError">{errors.mobileNumber}</span>
          </Grid>
          <Grid item xs={12}>
            <Box
              pl="10px"
              pr="10px"
              border="1px solid gray"
              borderRadius="20px"
            >
              <SelectFieldComponent
                id="user-roleId"
                name="roleId"
                value={userInput.roleId}
                options={allRoles}
                labelKey="roleDisplayName"
                optionKey="roleId"
                onChange={handleInputChange}
              />
            </Box>
            <span className="modalError">{errors.roleId}</span>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid
          container
          columnSpacing={2}
          display="flex"
          justifyContent="center"
          alignItems="center"
          mt="20px"
        >
          <Grid item xs={2}>
            <ButtonComponent
              fullWidth={false}
              loader={loader}
              disabled={loader}
              label="Save"
              onClick={() => handleEditUser(userId)}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EditUserModalBody;
